<bizz-modal modalSize="sm" [headerTemplate]="headerTemplateRef"
    [contentTemplate]="contentTemplateRef" [footerTemplate]="footerTemplateRef"></bizz-modal>

<ng-template #headerTemplateRef>
    <div class="modal-header">
        <h1 class="mb-5 text-center font-title text-xl font-bold text-default">
            {{ 'Title_YoureAuthCredentialsHaveExpired' | translate }}</h1>
    </div>
    <hr class="my-5" />
</ng-template>

<ng-template #contentTemplateRef>
    <div class="mt-6 flex w-full items-center gap-4 rounded bg-yellow-500/20 p-4 text-button">
        <bizz-icon iconName="circle-exclamation" class="size-8 text-yellow-500"></bizz-icon>
        {{ 'Info_PleaseReAuthenticateToContinueUsingTheApp' | translate }}
    </div>
</ng-template>

<ng-template #footerTemplateRef>
    <div class="modal-buttons">
        <button class="default" (click)="stayOffline()">
            {{ 'StayOffline' | translate }}
        </button>
        <button class="save min-w-16" (click)="login()">
            {{ 'Login' | translate }}
        </button>
    </div>
</ng-template>